module.exports = __webpack_public_path__ + "img/lianyungang.8a591064.png";